import React from 'react';
import { SiteContent } from 'components/common/styles';
import ContentLayout from 'components/ContentLayout';
import ZoneManagement from 'components/Admin/ZoneManagement';
// eslint-disable-next-line
export default function ZoneManagementScreen() {
  return (
    <ContentLayout>
      <SiteContent>
        <ZoneManagement />
      </SiteContent>
    </ContentLayout>
  );
}
